import { r as registerPlugin } from '../common/index-67482630.js';
import '../common/_polyfill-node:global-acbc543a.js';

const PushNotifications = registerPlugin('PushNotifications', {});

export { PushNotifications };
